import { lazy } from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const UploadMedia = lazy(() => import("@mediaspace/features/upload-media"));

const render = getDsLayoutComponentRenderer(UploadMedia);

export { render, UploadMedia };
